import { SvgIcon, SvgIconProps } from "@mui/material";

export const VerificationIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "17", fill: "none" }}
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.91667 0.00251055C5.71808 -0.0174772 3.52003 0.0818966 1.33227 0.300191C0.976969 0.315804 0.64109 0.466302 0.393409 0.720871C0.145728 0.975441 0.0049863 1.31482 0 1.66952C0.00477519 4.00333 -0.0495469 9.06748 0.762235 10.9351C1.53978 12.3065 2.54072 13.5393 3.72405 14.5829C4.58597 15.3223 6.67213 16.6667 7.91667 16.6667C9.1612 16.6667 11.2474 15.3194 12.1099 14.5829C13.2933 13.5393 14.2942 12.3066 15.0717 10.9351C15.8817 9.07224 15.773 4.02893 15.8333 1.68738C15.8258 1.33166 15.6827 0.992158 15.4333 0.737823C15.1838 0.483488 14.8467 0.333401 14.4903 0.318051C12.3059 0.100843 10.1118 -0.00447508 7.91667 0.00251055Z"
        fill="#008B07"
      />
      <path
        d="M4.75 7.40734L7.21296 10.0528L12.1389 4.76184"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const EmptySearchIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="240" height="180" viewBox="0 0 240 180" fill="none">
      <path
        d="M115.864 54.093C115.864 54.093 97.3238 40.4442 78.7898 42.3011C60.2558 44.1579 41.5298 67.9388 41.5298 67.9388L47.5298 72.4645C47.5298 72.4645 78.6278 46.791 95.4698 65.7715C112.312 84.752 115.864 54.093 115.864 54.093Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M115.864 54.093C115.864 54.093 97.3238 40.4442 78.7898 42.3011C60.2558 44.1579 41.5298 67.9388 41.5298 67.9388L47.5298 72.4645C47.5298 72.4645 78.6278 46.791 95.4698 65.7715C112.312 84.752 115.864 54.093 115.864 54.093Z"
        fill="white"
      />
      <path d="M101.86 52.1885H38.2002V93.1169H101.86V52.1885Z" fill="#A0A0A0" />
      <path
        opacity="0.45"
        d="M204.892 139.586C203.719 139.35 202.614 138.857 201.656 138.144C200.698 137.43 199.912 136.513 199.354 135.46V135.4L170.944 81.5635L155.308 92.5792L166.366 127.173C166.658 128.082 166.724 129.049 166.558 129.989C166.393 130.929 166.002 131.816 165.418 132.573C164.834 133.331 164.074 133.936 163.204 134.338C162.333 134.74 161.378 134.926 160.42 134.881C152.02 134.499 143.086 134.284 133.804 134.284C85.852 134.284 46.978 139.842 46.978 146.703C46.978 153.563 85.852 159.127 133.804 159.127C181.756 159.127 220.6 153.569 220.6 146.721C220.6 144.058 214.786 141.604 204.892 139.586Z"
        fill="#CFCFCF"
      />
      <path
        d="M114.544 142.648C114.544 142.648 115.432 145.634 118.066 145.986C120.7 146.338 121.252 148.971 118.834 149.509C116.416 150.046 110.434 146.673 110.434 146.673L110.812 142.881L114.544 142.648Z"
        fill="#106048"
      />
      <path
        d="M63.2619 142.141C63.2619 142.141 60.2139 142.798 59.6619 145.383C59.1099 147.968 56.4339 148.315 56.0619 145.873C55.6899 143.431 59.5479 137.765 59.5479 137.765L63.3159 138.439L63.2619 142.141Z"
        fill="#106048"
      />
      <path
        d="M63.6701 97.5649C63.6701 97.5649 60.8621 110.605 70.9721 116.193C81.0821 121.782 112.972 111.721 108.046 143.395H115.162C115.162 143.395 124.36 117.125 100.498 107.787L93.2561 99.6129L63.6701 97.5649Z"
        fill="#111111"
      />
      <path d="M161.845 88.1523L159.424 85.8506L144.286 101.615L146.706 103.916L161.845 88.1523Z" fill="#A0A0A0" />
      <path
        opacity="0.08"
        d="M161.845 88.1523L159.424 85.8506L144.286 101.615L146.706 103.916L161.845 88.1523Z"
        fill="#111111"
      />
      <path d="M160.666 87.0239L158.245 84.7222L143.107 100.486L145.527 102.788L160.666 87.0239Z" fill="#A0A0A0" />
      <path
        d="M167.249 89.9245C171.141 85.8718 172.094 80.4922 169.377 77.9087C166.661 75.3253 161.303 76.5164 157.411 80.5691C153.519 84.6218 152.567 90.0015 155.283 92.5849C158 95.1684 163.357 93.9773 167.249 89.9245Z"
        fill="#A0A0A0"
      />
      <path
        opacity="0.08"
        d="M167.249 89.9245C171.141 85.8718 172.094 80.4922 169.377 77.9087C166.661 75.3253 161.303 76.5164 157.411 80.5691C153.519 84.6218 152.567 90.0015 155.283 92.5849C158 95.1684 163.357 93.9773 167.249 89.9245Z"
        fill="#111111"
      />
      <path
        d="M166.067 88.8054C169.959 84.7527 170.912 79.373 168.195 76.7896C165.478 74.2061 160.121 75.3972 156.229 79.45C152.337 83.5027 151.384 88.8824 154.101 91.4658C156.818 94.0492 162.175 92.8581 166.067 88.8054Z"
        fill="#A0A0A0"
      />
      <path
        opacity="0.57"
        d="M164.397 87.2175C166.968 84.5403 167.598 80.9867 165.804 79.2804C164.009 77.574 160.47 78.3611 157.899 81.0383C155.328 83.7155 154.699 87.269 156.493 88.9753C158.288 90.6817 161.826 89.8947 164.397 87.2175Z"
        fill="white"
      />
      <path
        d="M140.95 55.5676C140.95 55.5676 138.244 59.4784 135.616 61.4009C135.361 61.5856 135.072 61.7186 134.766 61.7922C134.459 61.8658 134.141 61.8786 133.83 61.8298C133.518 61.781 133.22 61.6716 132.951 61.5078C132.682 61.3441 132.448 61.1292 132.262 60.8755C131.308 59.544 130.408 57.4663 131.602 55.1975L133.15 51.0957C133.551 50.3117 134.187 49.6705 134.969 49.26C135.751 48.8495 136.641 48.6899 137.518 48.803C140.8 48.994 142.714 53.269 140.95 55.5676Z"
        fill="#F4A28C"
      />
      <path d="M134.098 51.9375L121.888 56.8334L123.388 65.4788L132.19 58.332L134.098 51.9375Z" fill="#F4A28C" />
      <path
        d="M139.912 54.9704C138.738 54.0804 137.671 53.0586 136.732 51.9254C136.647 52.6929 136.339 53.4191 135.846 54.0151C135.352 54.6111 134.695 55.0509 133.954 55.2808C133.24 55.5148 132.467 55.4944 131.766 55.2232C131.066 54.9519 130.482 54.4468 130.114 53.7942L134.074 49.1371C134.615 48.4479 135.334 47.9175 136.154 47.6021C136.974 47.2868 137.864 47.1982 138.73 47.3459C139.479 47.4742 140.218 47.6497 140.944 47.8713C142.744 48.4684 143.998 50.988 145.978 51.0716C146.177 51.0813 146.371 51.1422 146.539 51.2484C146.707 51.3547 146.845 51.5025 146.939 51.6776C147.033 51.8527 147.079 52.049 147.074 52.2473C147.068 52.4456 147.011 52.6392 146.908 52.809C145.936 54.4151 143.812 56.457 141.214 55.6391C140.746 55.4889 140.306 55.263 139.912 54.9704Z"
        fill="#111111"
      />
      <path
        d="M134.44 55.4962C134.44 55.4962 135.58 54.0632 134.44 53.293C133.3 52.5228 131.626 54.5886 132.916 55.9678L134.44 55.4962Z"
        fill="#F4A28C"
      />
      <path
        d="M139.12 57.9438L138.976 60.1948C138.964 60.3207 138.92 60.4418 138.85 60.5469C138.779 60.6521 138.683 60.7382 138.57 60.7974C138.458 60.8565 138.333 60.887 138.205 60.8861C138.078 60.8851 137.953 60.8527 137.842 60.7918L136.216 59.8962L139.12 57.9438Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M131.2 59.126C131.2 59.126 131.566 56.4094 132.55 55.3765C132.55 55.3765 128.104 56.8691 128.002 61.7351L131.2 59.126Z"
        fill="#CE8172"
      />
      <path
        opacity="0.08"
        d="M50.5962 92.0598C50.5962 92.0598 50.4042 63.8965 84.4002 57.9438L64.4262 93.1166H50.6262L50.5962 92.0598Z"
        fill="#111111"
      />
      <path
        d="M125.008 68.47L124 62.6367C123.606 60.2577 122.611 58.0172 121.11 56.125C119.608 54.2329 117.648 52.7509 115.414 51.818C113.469 51.0443 111.436 50.5129 109.36 50.2358C106.696 49.8656 102.964 50.2358 98.7879 51.3284C80.7999 56.0272 67.5999 71.1925 64.8699 89.4745L63.6699 97.5646L93.2559 99.6125C93.2559 99.6125 91.7559 91.2537 102.256 91.2537C112.756 91.2537 126.052 91.3612 125.008 68.47Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M96.0159 59.4248C96.0159 59.4248 81.6579 61.9384 65.8779 84.5669L63.6699 97.5649L86.1219 99.2247L96.0159 59.4248Z"
        fill="#111111"
      />
      <path
        d="M112.48 69.8314C115.282 60.5292 104.416 53.0063 96.6702 58.9172C90.1902 63.8548 82.8702 72.745 82.5822 87.7491C82.0842 114.826 108.148 109.984 143.422 99.6127L142.3 91.7255C142.3 91.7255 100.06 99.6724 105.796 86.0117C108.196 80.2978 110.992 74.781 112.48 69.8314Z"
        fill="#106048"
      />
      <path
        opacity="0.2"
        d="M112.48 69.8314C115.282 60.5292 104.416 53.0063 96.6702 58.9172C90.1902 63.8548 82.8702 72.745 82.5822 87.7491C82.0842 114.826 108.148 109.984 143.422 99.6127L142.3 91.7255C142.3 91.7255 100.06 99.6724 105.796 86.0117C108.196 80.2978 110.992 74.781 112.48 69.8314Z"
        fill="white"
      />
      <path
        d="M97.6541 107.852C97.6541 107.852 98.5241 137.795 63.3161 143.395L61.9541 137.048C61.9541 137.048 90.1541 130.092 71.9381 111.458L97.6541 107.852Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M153.112 148.118C155.226 148.118 156.94 147.487 156.94 146.709C156.94 145.931 155.226 145.3 153.112 145.3C150.998 145.3 149.284 145.931 149.284 146.709C149.284 147.487 150.998 148.118 153.112 148.118Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M167.752 144.469C169.866 144.469 171.58 143.839 171.58 143.06C171.58 142.282 169.866 141.651 167.752 141.651C165.638 141.651 163.924 142.282 163.924 143.06C163.924 143.839 165.638 144.469 167.752 144.469Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M182.494 147.288C184.608 147.288 186.322 146.657 186.322 145.879C186.322 145.101 184.608 144.47 182.494 144.47C180.38 144.47 178.666 145.101 178.666 145.879C178.666 146.657 180.38 147.288 182.494 147.288Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M205.066 148.703C207.18 148.703 208.894 148.072 208.894 147.294C208.894 146.516 207.18 145.885 205.066 145.885C202.952 145.885 201.238 146.516 201.238 147.294C201.238 148.072 202.952 148.703 205.066 148.703Z"
        fill="#111111"
      />
      <path
        opacity="0.08"
        d="M138.598 144.153C140.759 144.153 142.51 143.507 142.51 142.709C142.51 141.911 140.759 141.264 138.598 141.264C136.437 141.264 134.686 141.911 134.686 142.709C134.686 143.507 136.437 144.153 138.598 144.153Z"
        fill="#111111"
      />
      <path
        d="M142.516 93.2421C142.516 93.2421 152.224 92.2211 153.076 95.9945C153.928 99.7679 152.068 101.768 143.332 98.9798L142.516 93.2421Z"
        fill="#F4A28C"
      />
      <path
        d="M45.8018 93.1168C45.8018 93.1168 47.1998 98.753 52.7978 97.5648C58.3958 96.3767 54.3998 89.4628 45.8018 93.1168Z"
        fill="#F4A28C"
      />
    </SvgIcon>
  );
};

export const NoResultsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="166px" height="117px" viewBox="0 0 166 117" fill="none">
      <path
        opacity="0.45"
        d="M38.1142 75.3146C58.8666 75.3146 75.6898 58.4659 75.6898 37.682C75.6898 16.898 58.8666 0.0493164 38.1142 0.0493164C17.3617 0.0493164 0.538574 16.898 0.538574 37.682C0.538574 58.4659 17.3617 75.3146 38.1142 75.3146Z"
        fill="#E7E7E7"
      />
      <path
        d="M43.1318 20.4096C43.1318 20.4096 44.2213 25.6688 43.7473 29.3076C43.7011 29.6603 43.5856 30.0004 43.4076 30.3082C43.2295 30.616 42.9923 30.8855 42.7097 31.101C42.4272 31.3166 42.1048 31.4739 41.7612 31.5641C41.4176 31.6542 41.0595 31.6754 40.7077 31.6263C38.8829 31.3644 36.4861 30.4697 35.56 27.7255L33.4138 23.2519C33.4138 23.2519 32.1718 20.4041 34.9172 17.8836C37.6627 15.3632 42.6252 17.169 43.1318 20.4096Z"
        fill="#F4A28C"
      />
      <path d="M33.8057 24.0645L33.1084 41.6587L42.8155 41.3478L39.4218 28.669L33.8057 24.0645Z" fill="#F4A28C" />
      <path
        d="M41.8625 20.7859C40.2235 21.0448 38.5603 21.1144 36.9054 20.9933C37.4668 21.6609 37.8207 22.4786 37.9233 23.3453C38.0259 24.2121 37.8728 25.09 37.4828 25.8705C37.1209 26.6354 36.504 27.2499 35.7385 27.6084C34.9729 27.9668 34.1065 28.0468 33.2884 27.8346L32.5639 20.9714C32.4251 19.9925 32.5545 18.9942 32.9382 18.0833C33.322 17.1723 33.9458 16.3829 34.7428 15.7995C35.43 15.2925 36.1487 14.8296 36.8945 14.4138C38.7739 13.3882 41.7971 14.3593 43.4313 12.8208C43.5934 12.6666 43.7927 12.5572 44.0097 12.5033C44.2267 12.4494 44.4539 12.4529 44.6692 12.5134C44.8844 12.5739 45.0803 12.6893 45.2376 12.8484C45.3949 13.0075 45.5083 13.2048 45.5667 13.4209C46.1114 15.4667 46.1386 18.7947 43.4585 20.2677C42.959 20.5281 42.4196 20.7032 41.8625 20.7859Z"
        fill="#111111"
      />
      <path
        d="M38.0098 25.6468C38.0098 25.6468 37.7265 23.5955 36.2012 23.9392C34.676 24.2829 35.0736 27.2453 37.1981 27.2726L38.0098 25.6468Z"
        fill="#F4A28C"
      />
      <path
        d="M43.6489 23.7593L45.3757 25.636C45.4729 25.7429 45.5417 25.8725 45.5758 26.013C45.6099 26.1535 45.6081 26.3004 45.5707 26.44C45.5332 26.5796 45.4613 26.7076 45.3616 26.8121C45.2618 26.9166 45.1374 26.9943 44.9998 27.0381L43.0061 27.6655L43.6489 23.7593Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M40.2809 31.4132C39.0519 31.2521 37.8968 30.7344 36.958 29.9238C36.958 29.9238 37.5027 33.1044 41.354 35.8431L40.2809 31.4132Z"
        fill="#CE8172"
      />
      <path
        d="M12.8004 65.4942C12.8004 65.4942 12.223 41.8715 37.662 40.6495C63.101 39.4274 62.4309 66.5362 62.4309 66.5362C62.4309 66.5362 38.43 88.4459 12.8004 65.4942Z"
        fill="#106048"
      />
      <path
        opacity="0.45"
        d="M126.872 75.2653C147.625 75.2653 164.448 58.4166 164.448 37.6326C164.448 16.8487 147.625 0 126.872 0C106.12 0 89.2969 16.8487 89.2969 37.6326C89.2969 58.4166 106.12 75.2653 126.872 75.2653Z"
        fill="#E7E7E7"
      />
      <path
        d="M131.884 20.3547C131.884 20.3547 132.974 25.6139 132.5 29.2582C132.454 29.6104 132.338 29.95 132.161 30.2574C131.983 30.5648 131.746 30.834 131.464 31.0495C131.182 31.2649 130.861 31.4225 130.518 31.513C130.175 31.6035 129.817 31.6252 129.466 31.5769C127.635 31.3095 125.244 30.4203 124.318 27.6707L122.172 23.2025C122.172 23.2025 120.924 20.3493 123.675 17.8342C126.426 15.3192 131.383 17.1141 131.884 20.3547Z"
        fill="#F4A28C"
      />
      <path d="M122.558 24.0103L121.861 41.6045L131.568 41.2936L128.179 28.6202L122.558 24.0103Z" fill="#F4A28C" />
      <path
        d="M126.763 25.592C126.763 25.592 126.48 23.5462 124.96 23.8844C123.44 24.2227 123.827 27.1905 125.957 27.2178L126.763 25.592Z"
        fill="#F4A28C"
      />
      <path
        d="M132.402 23.7046L134.129 25.5813C134.227 25.6882 134.297 25.8182 134.332 25.9594C134.367 26.1006 134.365 26.2483 134.328 26.3887C134.29 26.5292 134.218 26.6579 134.118 26.7628C134.017 26.8678 133.892 26.9455 133.753 26.9889L131.743 27.6108L132.402 23.7046Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M129.02 31.3586C127.795 31.2052 126.642 30.697 125.702 29.8965C125.702 29.8965 126.22 33.0771 130.098 35.8213L129.02 31.3586Z"
        fill="#CE8172"
      />
      <path
        d="M101.554 65.4395C101.554 65.4395 100.982 41.8168 126.421 40.5948C151.86 39.3727 151.19 66.4816 151.19 66.4816C151.19 66.4816 127.184 88.3912 101.554 65.4395Z"
        fill="#106048"
      />
      <path
        d="M62.1749 77.164C69.1365 77.164 74.78 71.5119 74.78 64.5398C74.78 57.5676 69.1365 51.9155 62.1749 51.9155C55.2133 51.9155 49.5698 57.5676 49.5698 64.5398C49.5698 71.5119 55.2133 77.164 62.1749 77.164Z"
        fill="#A0A0A0"
      />
      <path
        d="M152.856 77.164C159.818 77.164 165.461 71.5119 165.461 64.5398C165.461 57.5676 159.818 51.9155 152.856 51.9155C145.895 51.9155 140.251 57.5676 140.251 64.5398C140.251 71.5119 145.895 77.164 152.856 77.164Z"
        fill="#A0A0A0"
      />
      <path
        d="M62.1734 71.6536C61.8122 71.6536 61.4658 71.5099 61.2104 71.2541C60.955 70.9984 60.8115 70.6514 60.8115 70.2897V58.8112C60.8115 58.4494 60.955 58.1025 61.2104 57.8467C61.4658 57.591 61.8122 57.4473 62.1734 57.4473C62.5345 57.4473 62.8809 57.591 63.1363 57.8467C63.3917 58.1025 63.5352 58.4494 63.5352 58.8112V70.2679C63.5381 70.4488 63.505 70.6285 63.4378 70.7965C63.3707 70.9645 63.2709 71.1175 63.1441 71.2465C63.0174 71.3754 62.8663 71.4778 62.6996 71.5477C62.5329 71.6176 62.354 71.6536 62.1734 71.6536V71.6536Z"
        fill="white"
      />
      <path
        d="M68.1082 65.903H56.6253C56.2641 65.903 55.9177 65.7594 55.6623 65.5036C55.4069 65.2479 55.2634 64.9011 55.2634 64.5394C55.2634 64.1777 55.4069 63.8309 55.6623 63.5752C55.9177 63.3195 56.2641 63.1758 56.6253 63.1758H68.1082C68.4694 63.1758 68.8158 63.3195 69.0712 63.5752C69.3266 63.8309 69.47 64.1777 69.47 64.5394C69.47 64.9011 69.3266 65.2479 69.0712 65.5036C68.8158 65.7594 68.4694 65.903 68.1082 65.903V65.903Z"
        fill="white"
      />
      <path
        d="M152.856 71.6536C152.495 71.6536 152.148 71.5099 151.893 71.2541C151.638 70.9984 151.494 70.6514 151.494 70.2897V58.8112C151.494 58.4494 151.638 58.1025 151.893 57.8467C152.148 57.591 152.495 57.4473 152.856 57.4473C153.217 57.4473 153.564 57.591 153.819 57.8467C154.074 58.1025 154.218 58.4494 154.218 58.8112V70.2679C154.221 70.4488 154.188 70.6285 154.12 70.7965C154.053 70.9645 153.953 71.1175 153.827 71.2465C153.7 71.3754 153.549 71.4778 153.382 71.5477C153.216 71.6176 153.037 71.6536 152.856 71.6536V71.6536Z"
        fill="white"
      />
      <path
        d="M158.789 65.903H147.301C146.939 65.903 146.593 65.7594 146.338 65.5036C146.082 65.2479 145.939 64.9011 145.939 64.5394C145.939 64.1777 146.082 63.8309 146.338 63.5752C146.593 63.3195 146.939 63.1758 147.301 63.1758H158.789C159.15 63.1758 159.497 63.3195 159.752 63.5752C160.007 63.8309 160.151 64.1777 160.151 64.5394C160.151 64.9011 160.007 65.2479 159.752 65.5036C159.497 65.7594 159.15 65.903 158.789 65.903Z"
        fill="white"
      />
      <path
        d="M127.896 22.1334L135.8 21.4351C135.8 21.4351 134.825 15.7231 129.263 14.7466C123.702 13.77 120.499 16.8361 120.085 22.6899C119.671 28.5438 122.264 31.0315 122.264 31.0315C122.264 31.0315 129.454 31.1843 127.896 22.1334Z"
        fill="#111111"
      />
      <path
        d="M123.342 15.7119C123.342 15.7119 116.604 17.054 116.604 27.2395C116.604 37.4251 108.629 42.3515 115.215 48.4781C121.801 54.6048 132.369 50.6167 127.918 42.3515C123.468 34.0863 130.479 31.113 127.918 22.1658C125.358 13.2187 123.342 15.7119 123.342 15.7119Z"
        fill="#111111"
      />
      <path d="M68.2047 87.2729H10.6587V116.923H68.2047V87.2729Z" fill="#111111" />
      <path opacity="0.2" d="M60.9415 93.4268H16.8042V105.175H60.9415V93.4268Z" fill="white" />
      <path d="M157.597 87.2729H100.051V116.923H157.597V87.2729Z" fill="#111111" />
      <path opacity="0.2" d="M151.451 93.4268H107.314V105.175H151.451V93.4268Z" fill="white" />
    </SvgIcon>
  );
};

export const CompareIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 17H20M20 17L16 13M20 17L16 21M20 7H4M4 7L8 3M4 7L8 11"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const CloseCompareIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M15 5L5 15M5 5L15 15"
        stroke="#667085"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TrueIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
        stroke="#106048"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const FalseIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="22" height="22" viewBox="0 0 22 22" fill="none">
      <path
        d="M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
        stroke="#FF4D4E"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const AdvancedFilterIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "18px", height: "18px", fill: "none" }}
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M9.75 2.25L11.0506 5.63165C11.2621 6.18157 11.3679 6.45653 11.5324 6.68781C11.6781 6.8928 11.8572 7.07189 12.0622 7.21765C12.2935 7.3821 12.5684 7.48786 13.1184 7.69937L16.5 9L13.1184 10.3006C12.5684 10.5121 12.2935 10.6179 12.0622 10.7824C11.8572 10.9281 11.6781 11.1072 11.5324 11.3122C11.3679 11.5435 11.2621 11.8184 11.0506 12.3684L9.75 15.75L8.44937 12.3684C8.23786 11.8184 8.1321 11.5435 7.96765 11.3122C7.82189 11.1072 7.6428 10.9281 7.43781 10.7824C7.20653 10.6179 6.93157 10.5121 6.38165 10.3006L3 9L6.38165 7.69937C6.93157 7.48786 7.20653 7.3821 7.43781 7.21765C7.6428 7.07189 7.82189 6.8928 7.96765 6.68781C8.1321 6.45653 8.23786 6.18157 8.44937 5.63165L9.75 2.25Z"
        fill="#F3BC4E"
      />
      <path
        d="M3.375 16.5V12.75M3.375 5.25V1.5M1.5 3.375H5.25M1.5 14.625H5.25M9.75 2.25L8.44937 5.63165C8.23786 6.18157 8.1321 6.45653 7.96765 6.68781C7.82189 6.8928 7.6428 7.07189 7.43781 7.21765C7.20653 7.3821 6.93157 7.48786 6.38165 7.69937L3 9L6.38165 10.3006C6.93157 10.5121 7.20653 10.6179 7.43781 10.7824C7.6428 10.9281 7.82189 11.1072 7.96765 11.3122C8.1321 11.5435 8.23786 11.8184 8.44937 12.3684L9.75 15.75L11.0506 12.3684C11.2621 11.8184 11.3679 11.5435 11.5324 11.3122C11.6781 11.1072 11.8572 10.9281 12.0622 10.7824C12.2935 10.6179 12.5684 10.5121 13.1184 10.3006L16.5 9L13.1184 7.69937C12.5684 7.48786 12.2935 7.3821 12.0622 7.21765C11.8572 7.07189 11.6781 6.8928 11.5324 6.68781C11.3679 6.45653 11.2621 6.18157 11.0506 5.63165L9.75 2.25Z"
        stroke="#F3BC4E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
export const FollowIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "13px", height: "12px", fill: "none" }}
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
    >
      <g id="ic_plus">
        <path id="Vector 7" d="M6.5 1V11" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
        <path id="Vector 8" d="M11.5 6L1.5 6" stroke="#106048" strokeWidth="2" strokeLinecap="round" />
      </g>
    </SvgIcon>
  );
};

export const ChatIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "16", height: "16", fill: "none" }}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g id="Group">
        <path
          id="Vector"
          d="M13.2133 0.600916L1.27067 4.94683C0.988237 5.04887 0.755963 5.25602 0.622127 5.52503C0.488398 5.79415 0.463435 6.10441 0.552467 6.39138C0.641503 6.67834 0.837759 6.91998 1.10035 7.0659L6.13608 9.86367L8.93263 14.8982C9.03272 15.0816 9.18072 15.2344 9.3608 15.3404C9.54077 15.4463 9.74618 15.5015 9.95502 15.5H10.0454C10.2691 15.4834 10.4831 15.4023 10.6616 15.2664C10.84 15.1306 10.9753 14.9458 11.0508 14.7346L15.3948 2.78338C15.542 2.37525 15.5281 1.92632 15.3559 1.52817C15.1837 1.12989 14.8663 0.812361 14.4682 0.640046C14.0702 0.467848 13.6215 0.453932 13.2135 0.60116L13.2133 0.600916ZM14.0347 1.96485C14.1285 2.05654 14.1592 2.19496 14.1131 2.3177L9.91572 13.8615L7.48896 9.48001L10.8683 6.09248C11.0265 5.9179 11.0834 5.67399 11.0187 5.44734C10.954 5.22079 10.7769 5.04358 10.5505 4.97889C10.3239 4.9142 10.0801 4.97104 9.9056 5.12933L6.51953 8.51016L2.13989 6.08235L13.6803 1.88318C13.8038 1.83573 13.9436 1.86736 14.0347 1.96333L14.0347 1.96485Z"
          fill="#106048"
          stroke="#106048"
          strokeWidth="0.2"
        />
      </g>
    </SvgIcon>
  );
};

export const LeftPaginationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M15.8337 9.99984H4.16699M4.16699 9.99984L10.0003 15.8332M4.16699 9.99984L10.0003 4.1665"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const RightPaginationButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M4.16699 9.99984H15.8337M15.8337 9.99984L10.0003 4.1665M15.8337 9.99984L10.0003 15.8332"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TrendingTalentsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "33", fill: "none" }}
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
    >
      <path
        d="M22.6997 31.0588C22.6997 29.3644 22.0265 27.7393 20.8284 26.5412C19.6302 25.343 18.0052 24.6699 16.3108 24.6699C14.6163 24.6699 12.9913 25.343 11.7931 26.5412C10.595 27.7393 9.92188 29.3644 9.92188 31.0588"
        fill="white"
      />
      <path
        d="M22.6997 31.0588C22.6997 29.3644 22.0265 27.7393 20.8284 26.5412C19.6302 25.343 18.0052 24.6699 16.3108 24.6699C14.6163 24.6699 12.9913 25.343 11.7931 26.5412C10.595 27.7393 9.92188 29.3644 9.92188 31.0588"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.7775 18.2761C20.7775 19.4622 20.3063 20.5997 19.4676 21.4384C18.6289 22.2772 17.4914 22.7483 16.3052 22.7483C15.1191 22.7483 13.9816 22.2772 13.1429 21.4384C12.3042 20.5997 11.833 19.4622 11.833 18.2761C11.8303 17.3059 12.1493 16.3622 12.7402 15.5928C14.0598 16.8681 15.8122 17.5982 17.6469 17.6372C18.66 17.6497 19.6675 17.4854 20.6241 17.1517C20.7269 17.5176 20.7785 17.896 20.7775 18.2761Z"
        fill="white"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M18.875 28.6235V30.4201" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M20.6241 17.1514C19.6675 17.4851 18.66 17.6494 17.6469 17.6369C15.8122 17.5979 14.0598 16.8678 12.7402 15.5925C13.2431 14.9191 13.9262 14.4016 14.7106 14.1C15.4951 13.7984 16.3489 13.7248 17.1734 13.8878C17.9978 14.0509 18.7594 14.4438 19.37 15.0213C19.9806 15.5988 20.4154 16.3373 20.6241 17.1514Z"
        fill="#A1E3CB"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25.2549 31.0588V1.66992" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M18.8611 8.05355V9.33133C18.8628 9.4996 18.8309 9.66653 18.7673 9.82232C18.7037 9.97812 18.6097 10.1197 18.4907 10.2387C18.3717 10.3577 18.2301 10.4517 18.0743 10.5153C17.9185 10.5789 17.7516 10.6108 17.5833 10.6091H8L11.1944 7.41466L8 4.22021H16.3056V6.77577C16.3056 7.11466 16.4402 7.43967 16.6798 7.6793C16.9194 7.91893 17.2444 8.05355 17.5833 8.05355H18.8611Z"
        fill="#A1E3CB"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5834 1.66504C17.2446 1.66504 16.9195 1.79966 16.6799 2.03929C16.4403 2.27892 16.3057 2.60393 16.3057 2.94282V6.77615C16.3057 7.11504 16.4403 7.44005 16.6799 7.67968C16.9195 7.91931 17.2446 8.05393 17.5834 8.05393H25.2501V1.66504H17.5834Z"
        fill="#A1E3CB"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const TrendingProfessionalsIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "30", height: "30", fill: "none" }}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <g clipPath="url(#clip0_25057_2265)">
        <path
          d="M20.6246 11.1737L21.7496 11.9562L20.5483 14.7175C20.4957 14.8439 20.484 14.9837 20.515 15.1172C20.5459 15.2506 20.618 15.371 20.7209 15.4613C20.8238 15.5517 20.9525 15.6076 21.0888 15.621C21.2251 15.6344 21.3622 15.6048 21.4808 15.5362L24.3858 13.9025L27.2908 15.5362C27.4094 15.6053 27.5467 15.6353 27.6833 15.6221C27.8199 15.6088 27.9489 15.5531 28.0521 15.4626C28.1553 15.3721 28.2274 15.2515 28.2584 15.1178C28.2893 14.9841 28.2775 14.8441 28.2246 14.7175L27.0221 11.9562L29.1921 10.4437C29.2867 10.3601 29.3531 10.2493 29.3821 10.1264C29.4112 10.0035 29.4015 9.87469 29.3544 9.75756C29.3072 9.64043 29.225 9.54076 29.1189 9.47226C29.0129 9.40376 28.8882 9.36977 28.7621 9.37498H26.2621L24.9721 5.98248C24.9161 5.87446 24.8315 5.78389 24.7276 5.72068C24.6237 5.65746 24.5044 5.62402 24.3827 5.62402C24.261 5.62402 24.1417 5.65746 24.0378 5.72068C23.9338 5.78389 23.8493 5.87446 23.7933 5.98248L22.5083 9.37498H21.2496"
          fill="#A1E3CB"
        />
        <path
          d="M26.2616 9.37498L24.9729 5.98248C24.9169 5.87446 24.8323 5.78389 24.7284 5.72068C24.6245 5.65746 24.5051 5.62402 24.3835 5.62402C24.2618 5.62402 24.1425 5.65746 24.0386 5.72068C23.9346 5.78389 23.8501 5.87446 23.7941 5.98248L22.5091 9.37498H21.2504L20.6254 11.1725L21.7504 11.955L20.5491 14.7162C20.4952 14.8494 20.4873 14.9968 20.5266 15.135L26.2866 9.37498H26.2616Z"
          fill="white"
        />
        <path
          d="M9.37526 11.1737L8.25026 11.9562L9.45276 14.7175C9.50539 14.8439 9.51705 14.9837 9.4861 15.1172C9.45514 15.2506 9.38313 15.371 9.2802 15.4613C9.17727 15.5517 9.04859 15.6076 8.91227 15.621C8.77596 15.6344 8.63886 15.6048 8.52026 15.5362L5.61401 13.9025L2.70901 15.5362C2.59042 15.6048 2.45332 15.6344 2.317 15.621C2.18069 15.6076 2.05201 15.5517 1.94908 15.4613C1.84614 15.371 1.77414 15.2506 1.74318 15.1172C1.71223 14.9837 1.72388 14.8439 1.77651 14.7175L2.97901 11.9562L0.809013 10.4437C0.714407 10.3601 0.648012 10.2493 0.618951 10.1264C0.589891 10.0035 0.59959 9.87469 0.646716 9.75756C0.693843 9.64043 0.776084 9.54076 0.882141 9.47226C0.988197 9.40376 1.11286 9.36977 1.23901 9.37498H3.73901L5.02651 5.98248C5.08247 5.87446 5.16704 5.78389 5.27098 5.72068C5.37492 5.65746 5.49423 5.62402 5.61589 5.62402C5.73754 5.62402 5.85686 5.65746 5.9608 5.72068C6.06474 5.78389 6.14931 5.87446 6.20526 5.98248L7.48901 9.37498H8.75026"
          fill="#A1E3CB"
        />
        <path
          d="M1.74975 14.9862L7.44975 9.28498L6.19975 5.98248C6.1438 5.87446 6.05923 5.78389 5.95529 5.72068C5.85135 5.65746 5.73203 5.62402 5.61038 5.62402C5.48872 5.62402 5.36941 5.65746 5.26546 5.72068C5.16152 5.78389 5.07696 5.87446 5.021 5.98248L3.73975 9.37498H1.23975C1.11357 9.36935 0.988756 9.40302 0.882531 9.47135C0.776306 9.53968 0.693911 9.6393 0.646718 9.75646C0.599526 9.87362 0.589865 10.0025 0.619068 10.1254C0.648271 10.2483 0.714898 10.3591 0.809752 10.4425L2.9785 11.955L1.77725 14.7162C1.74842 14.8031 1.73903 14.8953 1.74975 14.9862Z"
          fill="white"
        />
        <path
          d="M15.5966 0.982485L16.8816 4.37498H19.3816C19.5075 4.37023 19.6319 4.40445 19.7377 4.47297C19.8435 4.54149 19.9255 4.64098 19.9727 4.75786C20.0198 4.87474 20.0298 5.00332 20.0012 5.12607C19.9726 5.24881 19.9068 5.35975 19.8128 5.44374L17.6428 6.95623L18.8453 9.71749C18.898 9.84395 18.9096 9.98373 18.8787 10.1172C18.8477 10.2506 18.7757 10.371 18.6728 10.4613C18.5698 10.5517 18.4412 10.6076 18.3049 10.621C18.1685 10.6344 18.0314 10.6048 17.9128 10.5362L15.0078 8.90248L12.1016 10.5362C11.983 10.6048 11.8459 10.6344 11.7096 10.621C11.5733 10.6076 11.4446 10.5517 11.3417 10.4613C11.2387 10.371 11.1667 10.2506 11.1358 10.1172C11.1048 9.98373 11.1165 9.84395 11.1691 9.71749L12.3753 6.95623L10.2016 5.44374C10.107 5.36013 10.0406 5.24927 10.0115 5.12641C9.98247 5.00354 9.99217 4.87469 10.0393 4.75756C10.0864 4.64043 10.1687 4.54076 10.2747 4.47226C10.3808 4.40376 10.5054 4.36977 10.6316 4.37498H13.1316L14.4178 0.982485C14.4738 0.874461 14.5584 0.783893 14.6623 0.720676C14.7662 0.657459 14.8856 0.624023 15.0072 0.624023C15.1289 0.624023 15.2482 0.657459 15.3521 0.720676C15.4561 0.783893 15.5406 0.874461 15.5966 0.982485Z"
          fill="#A1E3CB"
        />
        <path
          d="M16.8811 4.37498L15.5961 0.982485C15.5401 0.874461 15.4556 0.783893 15.3516 0.720676C15.2477 0.657459 15.1284 0.624023 15.0067 0.624023C14.8851 0.624023 14.7657 0.657459 14.6618 0.720676C14.5579 0.783893 14.4733 0.874461 14.4173 0.982485L13.1311 4.37498H10.6311C10.5052 4.37009 10.3809 4.4042 10.2752 4.47265C10.1694 4.5411 10.0874 4.64055 10.0404 4.75739C9.9933 4.87423 9.98348 5.00275 10.0123 5.12539C10.041 5.24802 10.107 5.35877 10.2011 5.44248L12.3748 6.95499L11.1686 9.71623C11.1142 9.86087 11.1142 10.0203 11.1686 10.165L16.9561 4.37498H16.8811Z"
          fill="white"
        />
        <path
          d="M15.5966 0.982485L16.8816 4.37498H19.3816C19.5075 4.37023 19.6319 4.40445 19.7377 4.47297C19.8435 4.54149 19.9255 4.64098 19.9727 4.75786C20.0198 4.87474 20.0298 5.00332 20.0012 5.12607C19.9726 5.24881 19.9068 5.35975 19.8128 5.44373L17.6428 6.95623L18.8453 9.71749C18.898 9.84395 18.9096 9.98373 18.8787 10.1172C18.8477 10.2506 18.7757 10.371 18.6728 10.4613C18.5698 10.5517 18.4412 10.6076 18.3049 10.621C18.1685 10.6344 18.0314 10.6048 17.9128 10.5362L15.0078 8.90249L12.1016 10.5362C11.983 10.6048 11.8459 10.6344 11.7096 10.621C11.5733 10.6076 11.4446 10.5517 11.3417 10.4613C11.2387 10.371 11.1667 10.2506 11.1358 10.1172C11.1048 9.98373 11.1165 9.84395 11.1691 9.71749L12.3753 6.95623L10.2016 5.44373C10.107 5.36013 10.0406 5.24927 10.0115 5.12641C9.98247 5.00354 9.99217 4.87469 10.0393 4.75756C10.0864 4.64043 10.1687 4.54076 10.2747 4.47226C10.3808 4.40376 10.5054 4.36977 10.6316 4.37498H13.1316L14.4178 0.982485C14.4738 0.874461 14.5584 0.783893 14.6623 0.720676C14.7662 0.657459 14.8856 0.624023 15.0072 0.624023C15.1289 0.624023 15.2482 0.657459 15.3521 0.720676C15.4561 0.783893 15.5406 0.874461 15.5966 0.982485Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.37526 11.1737L8.25026 11.9562L9.45276 14.7175C9.50539 14.8439 9.51705 14.9837 9.4861 15.1172C9.45514 15.2506 9.38313 15.371 9.2802 15.4613C9.17727 15.5517 9.04859 15.6076 8.91227 15.621C8.77596 15.6344 8.63886 15.6048 8.52026 15.5362L5.61401 13.9025L2.70901 15.5362C2.59042 15.6048 2.45332 15.6344 2.317 15.621C2.18069 15.6076 2.05201 15.5517 1.94908 15.4613C1.84614 15.371 1.77414 15.2506 1.74318 15.1172C1.71223 14.9837 1.72388 14.8439 1.77651 14.7175L2.97901 11.9562L0.809013 10.4437C0.714407 10.3601 0.648012 10.2493 0.618951 10.1264C0.589891 10.0035 0.59959 9.87469 0.646716 9.75756C0.693843 9.64043 0.776084 9.54076 0.882141 9.47226C0.988197 9.40376 1.11286 9.36977 1.23901 9.37498H3.73901L5.02651 5.98248C5.08247 5.87446 5.16704 5.78389 5.27098 5.72068C5.37492 5.65746 5.49423 5.62402 5.61589 5.62402C5.73754 5.62402 5.85686 5.65746 5.9608 5.72068C6.06474 5.78389 6.14931 5.87446 6.20526 5.98248L7.48901 9.37498H8.75026"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6246 11.1737L21.7496 11.9562L20.5483 14.7175C20.4957 14.8439 20.484 14.9837 20.515 15.1172C20.5459 15.2506 20.618 15.371 20.7209 15.4613C20.8238 15.5517 20.9525 15.6076 21.0888 15.621C21.2251 15.6344 21.3622 15.6048 21.4808 15.5362L24.3858 13.9025L27.2908 15.5362C27.4094 15.6053 27.5467 15.6353 27.6833 15.6221C27.8199 15.6088 27.9489 15.5531 28.0521 15.4626C28.1553 15.3721 28.2274 15.2515 28.2584 15.1178C28.2893 14.9841 28.2775 14.8441 28.2246 14.7175L27.0221 11.9562L29.1921 10.4437C29.2867 10.3601 29.3531 10.2493 29.3821 10.1264C29.4112 10.0035 29.4015 9.87469 29.3544 9.75756C29.3072 9.64043 29.225 9.54076 29.1189 9.47226C29.0129 9.40376 28.8882 9.36977 28.7621 9.37498H26.2621L24.9721 5.98248C24.9161 5.87446 24.8315 5.78389 24.7276 5.72068C24.6237 5.65746 24.5044 5.62402 24.3827 5.62402C24.261 5.62402 24.1417 5.65746 24.0378 5.72068C23.9338 5.78389 23.8493 5.87446 23.7933 5.98248L22.5083 9.37498H21.2496"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.043 24.375C15.8465 24.375 16.6319 24.1367 17.3 23.6903C17.968 23.244 18.4887 22.6095 18.7962 21.8672C19.1037 21.1248 19.1842 20.308 19.0274 19.5199C18.8707 18.7319 18.4837 18.008 17.9156 17.4399C17.3474 16.8717 16.6236 16.4848 15.8355 16.3281C15.0475 16.1713 14.2306 16.2518 13.4883 16.5592C12.746 16.8667 12.1115 17.3874 11.6651 18.0555C11.2187 18.7236 10.9805 19.509 10.9805 20.3125C10.9805 21.3899 11.4085 22.4233 12.1703 23.1851C12.9322 23.947 13.9655 24.375 15.043 24.375Z"
          fill="white"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.6055 29.375C19.9964 28.4378 19.1628 27.6677 18.1805 27.1346C17.1981 26.6015 16.0981 26.3223 14.9805 26.3223C13.8628 26.3223 12.7628 26.6015 11.7805 27.1346C10.7981 27.6677 9.96457 28.4378 9.35547 29.375"
          fill="#A1E3CB"
        />
        <path
          d="M20.6055 29.375C19.9964 28.4378 19.1628 27.6677 18.1805 27.1346C17.1981 26.6015 16.0981 26.3223 14.9805 26.3223C13.8628 26.3223 12.7628 26.6015 11.7805 27.1346C10.7981 27.6677 9.96457 28.4378 9.35547 29.375"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_25057_2265">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>{" "}
    </SvgIcon>
  );
};

export const TrendingEntitiesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "30", height: "30", fill: "none" }}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
    >
      <path
        d="M1.875 4.71865V14.2649C1.91173 17.4193 2.91697 20.4861 4.75461 23.0502C6.59224 25.6142 9.17347 27.5516 12.1488 28.5999L13.55 29.1174C14.4861 29.4612 15.5139 29.4612 16.45 29.1174L17.8512 28.5999C20.8265 27.5516 23.4078 25.6142 25.2454 23.0502C27.083 20.4861 28.0883 17.4193 28.125 14.2649V4.71865C28.1237 4.3436 28.0125 3.97716 27.8049 3.66475C27.5974 3.35234 27.3027 3.1077 26.9575 2.96115C23.171 1.38072 19.1029 0.585902 15 0.624904C10.8971 0.585902 6.82901 1.38072 3.0425 2.96115C2.69726 3.1077 2.40261 3.35234 2.19508 3.66475C1.98755 3.97716 1.87626 4.3436 1.875 4.71865Z"
        fill="#A1E3CB"
      />
      <path
        d="M15 0.624904C10.8971 0.585902 6.82901 1.38072 3.0425 2.96115C2.69726 3.1077 2.40261 3.35234 2.19508 3.66475C1.98755 3.97716 1.87626 4.3436 1.875 4.71865V14.2649C1.91173 17.4193 2.91697 20.4861 4.75461 23.0502C6.59224 25.6142 9.17347 27.5516 12.1488 28.5999L13.55 29.1174C14.0145 29.2877 14.5053 29.3749 15 29.3749V0.624904Z"
        fill="white"
      />
      <path
        d="M14.0673 7.29138C14.0029 7.26658 13.9321 7.2638 13.866 7.28347C13.7998 7.30313 13.742 7.34414 13.7016 7.40009C13.6612 7.45604 13.6405 7.52379 13.6427 7.59276C13.6448 7.66173 13.6697 7.72806 13.7135 7.78138C14.4212 8.69695 14.8494 9.79737 14.9467 10.9504C15.0441 12.1035 14.8064 13.2601 14.2623 14.2814C13.6079 13.8297 13.1151 13.1806 12.856 12.4289C12.8442 12.385 12.8229 12.3442 12.7937 12.3093C12.7645 12.2745 12.728 12.2464 12.6869 12.227C12.6458 12.2076 12.6009 12.1974 12.5554 12.1971C12.51 12.1968 12.465 12.2063 12.4235 12.2251C11.4304 12.6288 10.582 13.3227 9.98929 14.216C9.39656 15.1093 9.087 16.1606 9.10104 17.2326C9.10104 18.7971 9.72252 20.2974 10.8287 21.4037C11.935 22.5099 13.4353 23.1314 14.9998 23.1314C16.5642 23.1314 18.0646 22.5099 19.1708 21.4037C20.2771 20.2974 20.8985 18.7971 20.8985 17.2326C20.8735 15.0851 20.2107 12.9934 18.9944 11.2234C17.7781 9.4533 16.0631 8.08469 14.0673 7.29138Z"
        fill="#A1E3CB"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.875 4.71865V14.2649C1.91173 17.4193 2.91697 20.4861 4.7546 23.0502C6.59224 25.6142 9.17347 27.5516 12.1487 28.5999L13.55 29.1174C14.4861 29.4612 15.5139 29.4612 16.45 29.1174L17.8513 28.5999C20.8265 27.5516 23.4078 25.6142 25.2454 23.0502C27.083 20.4861 28.0883 17.4193 28.125 14.2649V4.71865C28.1237 4.3436 28.0125 3.97716 27.8049 3.66475C27.5974 3.35234 27.3027 3.1077 26.9575 2.96115C23.171 1.38072 19.1029 0.585902 15 0.624904C10.8971 0.585902 6.82901 1.38072 3.0425 2.96115C2.69726 3.1077 2.40261 3.35234 2.19508 3.66475C1.98755 3.97716 1.87626 4.3436 1.875 4.71865Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const ComingSoonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{
        width: "96",
        height: "66",
        fill: "none",
      }}
      width="96"
      height="66"
      viewBox="0 0 96 66"
      fill="none"
    >
      <path
        d="M41.0878 4.05121C41.0878 4.05121 41.154 6.48129 41.7436 8.02265C41.8015 8.17196 41.8884 8.30841 41.9995 8.42418C42.1105 8.53996 42.2434 8.63277 42.3906 8.69728C42.5377 8.76179 42.6963 8.79674 42.857 8.80012C43.0178 8.8035 43.1777 8.77524 43.3275 8.71696C44.1054 8.41147 45.0718 7.76923 45.1939 6.4674L45.6718 4.29074C45.7226 3.8432 45.6324 3.39102 45.4136 2.99673C45.1949 2.60244 44.8584 2.28551 44.4508 2.08978C42.9751 1.2705 40.9726 2.57927 41.0878 4.05121Z"
        fill="#F4A28C"
      />
      <path d="M44.469 4.31152L48.9275 10.897L45.104 13.0806L43.3945 7.41508L44.469 4.31152Z" fill="#F4A28C" />
      <path
        d="M43.8945 5.81823C43.8945 5.81823 43.8038 4.89133 44.5015 4.88092C45.1992 4.87051 45.3458 6.21399 44.4073 6.44658L43.8945 5.81823Z"
        fill="#F4A28C"
      />
      <path
        d="M41.2073 5.57471L40.6422 6.578C40.6095 6.63473 40.5918 6.69882 40.5909 6.76423C40.5899 6.82963 40.6057 6.8942 40.6368 6.95185C40.6678 7.00949 40.7131 7.05833 40.7684 7.09374C40.8237 7.12916 40.8871 7.14999 40.9527 7.15428L41.8981 7.22371L41.2073 5.57471Z"
        fill="#F4A28C"
      />
      <path
        opacity="0.31"
        d="M43.6953 8.51593C44.0833 8.10745 44.3417 7.59429 44.4384 7.04053C44.4384 7.04053 44.8884 8.3979 44.3163 10.4635L43.6953 8.51593Z"
        fill="#CE8172"
      />
      <path
        d="M45.1116 6.43255C45.4527 6.43255 45.7291 6.15745 45.7291 5.81808C45.7291 5.47872 45.4527 5.20361 45.1116 5.20361C44.7706 5.20361 44.4941 5.47872 44.4941 5.81808C44.4941 6.15745 44.7706 6.43255 45.1116 6.43255Z"
        fill="#F4A28C"
      />
      <path
        d="M5.80511 36.2779C9.01119 36.2779 11.6102 33.6916 11.6102 30.5012C11.6102 27.3109 9.01119 24.7246 5.80511 24.7246C2.59904 24.7246 0 27.3109 0 30.5012C0 33.6916 2.59904 36.2779 5.80511 36.2779Z"
        fill="#CFCFCF"
      />
      <path
        d="M41.5572 4.38445C42.3561 4.78021 42.5515 4.68647 43.6958 4.50595C43.6958 4.50595 44.1528 10.3416 47.7566 8.46351C49.9788 7.30402 47.5821 5.8182 46.4692 3.14858C45.3564 0.478968 44.7249 -0.361145 42.9422 0.135286C42.2494 0.369151 41.6226 0.764294 41.1142 1.28784C40.8905 1.49835 40.7208 1.75916 40.6193 2.0484C40.5179 2.33763 40.4876 2.64686 40.5309 2.95016C40.5743 3.25346 40.6902 3.54199 40.8688 3.79155C41.0473 4.0411 41.2834 4.24442 41.5572 4.38445V4.38445Z"
        fill="#111111"
      />
      <path
        d="M51.5782 40.8984L50.2071 45.5156C49.7253 47.1388 49.5924 48.8447 49.8171 50.5224C50.0418 52.2001 50.619 53.8118 51.5112 55.2528C52.4034 56.6938 53.5905 57.9316 54.9954 58.8857C56.4002 59.8398 57.9912 60.4888 59.6648 60.7904L70.6959 62.7796V59.676L62.4348 56.3121C61.7782 56.044 61.1817 55.6488 60.6799 55.1494C60.1781 54.65 59.781 54.0564 59.5116 53.403C59.2422 52.7497 59.1059 52.0495 59.1107 51.3433C59.1154 50.6371 59.2611 49.9389 59.5392 49.2892L61.3429 45.0782L51.5782 40.8984Z"
        fill="#F4A28C"
      />
      <path
        d="M67.3201 9.75488L81.6864 16.6008C83.0539 17.2537 84.2175 18.264 85.0529 19.5238L91.5976 29.3622L89.3021 31.6395L77.5698 23.0058L62.293 18.9094L67.3201 9.75488Z"
        fill="#F4A28C"
      />
      <path
        d="M45.1039 13.0805L48.9414 10.8968C48.9414 10.8968 56.4525 3.72463 67.3336 9.75471C78.2147 15.7848 62.2925 40.1099 62.2925 40.1099L46.3424 37.7284C46.3424 37.7284 50.0822 29.9799 39.7977 24.7067L35.7578 20.8185C35.7578 20.8185 41.2838 15.2675 45.1039 13.0805Z"
        fill="#106048"
      />
      <path
        opacity="0.08"
        d="M65.88 23.1723C65.88 23.1723 68.3046 25.8385 63.9507 27.2132C59.5969 28.588 54.5313 33.8578 52.9056 38.7075L46.3574 37.7285C46.3574 37.7285 47.4982 35.6456 46.7691 32.306C46.04 28.9663 58.2119 22.3843 65.88 23.1723Z"
        fill="#111111"
      />
      <path
        d="M35.7584 20.8188C35.7584 20.8188 30.2987 25.3319 32.4756 30.3622C34.6525 35.3924 44.9161 34.2017 53.4424 29.3762C61.9686 24.5508 63.3571 23.7315 63.3571 23.7315L61.7732 20.8223L44.1521 26.1616L35.7584 20.8188Z"
        fill="#F4A28C"
      />
      <path
        d="M61.7734 20.8187C61.7734 20.8187 66.525 20.0203 67.4844 21.7908C69.2566 25.054 63.9504 24.8179 63.3573 23.7279L61.7734 20.8187Z"
        fill="#111111"
      />
      <path d="M65.8789 9.02246L77.8136 14.7575L75.846 22.5476L69.4129 20.8188L65.8789 9.02246Z" fill="#106048" />
      <path d="M74.0667 12.9556L72.4863 21.6448L75.1342 22.3183L76.8785 14.306L74.0667 12.9556Z" fill="#111111" />
      <path
        d="M62.7322 39.6311L46.21 36.7636C41.3516 35.9193 36.3651 36.1637 31.6135 37.4788L17.1426 41.4815V45.3384L35.915 43.9046C37.919 43.7517 39.934 43.8215 41.9225 44.1129L55.1793 46.057C56.0349 46.182 56.9069 46.1372 57.745 45.9252C58.5831 45.7133 59.3707 45.3383 60.0625 44.8219C60.7542 44.3056 61.3364 43.658 61.7755 42.9167C62.2145 42.1753 62.5018 41.3548 62.6206 40.5025L62.7322 39.6311Z"
        fill="#F4A28C"
      />
      <path
        d="M42.3719 35.3818L41.8975 44.755C41.8975 44.755 59.2744 48.9209 62.306 47.0254C65.3376 45.13 62.7316 39.6449 62.7316 39.6449L42.3719 35.3818Z"
        fill="#111111"
      />
      <path
        d="M17.1423 41.4812C17.1423 41.4812 11.4942 39.0269 9.31728 40.11C7.14037 41.1931 14.6619 44.623 14.6619 44.623C14.6619 44.623 14.9759 47.4974 17.1423 45.3173V41.4812Z"
        fill="#106048"
      />
      <path
        d="M69.8145 62.5851C69.8145 62.5851 73.7183 65.7338 75.6615 65.3623C77.6047 64.9909 72.4554 60.6514 72.4554 60.6514C72.4554 60.6514 72.8322 58.3255 70.6552 59.5648L69.8145 62.5851Z"
        fill="#106048"
      />
      <path d="M17.1426 41.4812L31.6135 37.4785L31.9624 44.2064L17.1426 45.3381V41.4812Z" fill="#106048" />
      <path opacity="0.46" d="M17.1426 41.4812L31.6135 37.4785L31.9624 44.2064L17.1426 45.3381V41.4812Z" fill="white" />
      <path
        d="M41.0889 4.05127L41.1377 4.88096C41.1377 4.88096 41.654 5.55791 43.7576 5.00594L43.6948 4.50604C43.6948 4.50604 42.1529 4.67961 41.0889 4.05127Z"
        fill="#106048"
      />
      <path
        d="M48.9282 45.3383C48.9282 45.3383 47.9968 53.8019 52.2146 56.2632L59.5407 53.486C59.5407 53.486 58.6546 51.4794 60.3082 47.4663C61.9618 43.4532 48.9282 45.3383 48.9282 45.3383Z"
        fill="#111111"
      />
      <path d="M70.6547 59.5545L62.4355 56.312L60.4609 60.9327L69.814 62.5852L70.6547 59.5545Z" fill="#106048" />
      <path
        opacity="0.46"
        d="M70.6547 59.5545L62.4355 56.312L60.4609 60.9327L69.814 62.5852L70.6547 59.5545Z"
        fill="white"
      />
      <path
        opacity="0.08"
        d="M44.1525 26.1617L40.5906 26.9011C40.5906 26.9011 39.1463 23.0373 41.8989 20.8051C44.6514 18.5729 49.0262 20.7634 50.8473 24.1274L44.1525 26.1617Z"
        fill="#111111"
      />
      <path
        opacity="0.46"
        d="M58.3481 18.569C59.5176 18.569 60.4656 17.6255 60.4656 16.4617C60.4656 15.2979 59.5176 14.3545 58.3481 14.3545C57.1785 14.3545 56.2305 15.2979 56.2305 16.4617C56.2305 17.6255 57.1785 18.569 58.3481 18.569Z"
        fill="white"
      />
      <path
        d="M89.2881 31.6397C89.2881 31.6397 91.5627 34.5974 95.0269 33.1185C98.4911 31.6396 91.5976 29.3623 91.5976 29.3623L89.2881 31.6397Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};
